import React from "react";
import Cookies from 'js-cookie'
import axios from "axios";
function SitePotentialD(props) {
  const [value, setValue] = React.useState(null);
  const [ischecked, setchecked] = React.useState(null);
  const [ischecked1, setchecked1] = React.useState(null);
  const [structureType, SetstructureType] = React.useState("Per Home");
  const [IsStyle, SetStyle] = React.useState("form-control construction");
  const [isChecked, setIsChecked] = React.useState(false);

  const [loading, setLoading] = React.useState(false);
  React.useEffect(() => {


    console.log(props)


    // if(props.object["Site Potential"].find((item) => item.ParameterId == 1000 && item.structureType==props.structureType))
    // {
    // if(props.id==1000)
    // {

    //   var structuretype=props.structureType;
    //   var isDefault=props.object["Site Potential"].find((item) => item.ParameterId == 1000 && item.structureType==props.structureType).value;

    //   if(isDefault=="false")
    //   {

    //     var divElement = document.querySelector('.Tab-'+structuretype.replace(/\s/g, ""));

    //     // Retrieve all input elements within the div
    //     var inputElements = divElement.querySelectorAll('input');

    //     // Iterate over each input element and set the readOnly property
    //     for (var i = 0; i < inputElements.length; i++) {
    //       inputElements[i].readOnly = true;
    //     }
    //     document.getElementById("290-"+props.structureType+"-btn").style.display = "none";
    //     document.getElementById("289-"+props.structureType+"-btn").style.display = "none";

    //   }

    // }
    // }
    if (props.value == "") {
      //setValue(0);
    }
    else {

      if (props.object["Site Potential"].find((item) => item.ParameterId == 217)) {
        var usedFloor = props.object["Site Potential"].find((item) => item.ParameterId == 217).value;
        var maxFloor = props.object["Site Potential"].find((item) => item.ParameterId == 86).value;

        if (parseFloat(usedFloor) > parseFloat(maxFloor)) {
          document.getElementById(props.structureType + "-217").style.border = "2px solid red";
        }
        else {
          document.getElementById(props.structureType + "-217").style.border = "1px solid rgba(0, 0, 0, 0.2)";
        }

      }

      setValue(props.value);
    }
    if (props.structureType == "Single Family") { SetstructureType("Per Lot") }
    if (props.structureType == "Apartment" || props.structureType == "Condo") { SetstructureType("Per Unit") }

    //let val = props.wholeEl.ischecked.slice(1, props.wholeEl.ischecked.length - 1);
    if (props.ischecked === true) {
      var pclass = IsStyle;
      SetStyle("form-control construction ischecked");
    }
    setchecked(props.wholeEl.ischecked === true ? "checked" : false);
    setchecked1(props.wholeEl.ischecked);

    if (props.id == 1000 && props.IsManual == 0) {
      if (props.value == "false") {
        setIsChecked(false);


      }
      else setIsChecked(true);
    }
  }, []);



  const onChange = (e) => {
    setValue(e.target.value);
    let checkid = e.target.id;
    let parameterid = checkid.split('-')[1]
    let structuretype = "";
    if (checkid.includes("Single Family")) {
      structuretype = "Single Family"
    }
    if (checkid.includes("Townhome")) {
      structuretype = "Townhome"
    }
    if (checkid.includes("Cottage")) {
      structuretype = "Cottage"
    }
    if (checkid.includes("Rowhouse")) {
      structuretype = "Rowhouse"
    }
    if (checkid.includes("Condo")) {
      structuretype = "Condo"
    }
    if (checkid.includes("Apartment")) {
      structuretype = "Apartment"
    }
    setchecked(true);
    setchecked1(true);
    //  props.data.find((item) => item.ParameterId == parameterid && item.structureType==structuretype).ischecked=true;



    if (structuretype == "Single Family") {
      if (parameterid == 37) {
        props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
        props.object["Site Potential"].find((item) => item.ParameterId == 249 && item.structureType == structuretype).ischecked = false;
        props.object["Site Potential"].find((item) => item.ParameterId == 250 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-249").style.background = "#f7fafd";
        document.getElementById(structuretype + "-250").style.background = "#f7fafd";


        props.object["Site Potential"].find((item) => item.ParameterId == 249 && item.structureType == structuretype).value = 0;
        props.object["Site Potential"].find((item) => item.ParameterId == 250 && item.structureType == structuretype).value = 0;
        document.getElementById(structuretype + "-249").value = 0;
        document.getElementById(structuretype + "-250").value = 0;

      }
      if (parameterid == 249) {
        props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
        props.object["Site Potential"].find((item) => item.ParameterId == 37 && item.structureType == structuretype).ischecked = false;
        props.object["Site Potential"].find((item) => item.ParameterId == 250 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-37").style.background = "#f7fafd";
        document.getElementById(structuretype + "-250").style.background = "#f7fafd";

        props.object["Site Potential"].find((item) => item.ParameterId == 37 && item.structureType == structuretype).value = 0;
        props.object["Site Potential"].find((item) => item.ParameterId == 250 && item.structureType == structuretype).value = 0;
        document.getElementById(structuretype + "-37").value = 0;
        document.getElementById(structuretype + "-250").value = 0;

      }
      if (parameterid == 250) {
        props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
        props.object["Site Potential"].find((item) => item.ParameterId == 37 && item.structureType == structuretype).ischecked = false;
        props.object["Site Potential"].find((item) => item.ParameterId == 249 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-37").style.background = "#f7fafd";
        document.getElementById(structuretype + "-249").style.background = "#f7fafd";

        props.object["Site Potential"].find((item) => item.ParameterId == 37 && item.structureType == structuretype).value = 0;
        props.object["Site Potential"].find((item) => item.ParameterId == 249 && item.structureType == structuretype).value = 0;
        document.getElementById(structuretype + "-37").value = 0;
        document.getElementById(structuretype + "-249").value = 0;

      }

      if (parameterid == 251) {
        props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
        props.object["Site Potential"].find((item) => item.ParameterId == 38 && item.structureType == structuretype).ischecked = false;
        props.object["Site Potential"].find((item) => item.ParameterId == 252 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-38").style.background = "#f7fafd";
        document.getElementById(structuretype + "-252").style.background = "#f7fafd";

        props.object["Site Potential"].find((item) => item.ParameterId == 38 && item.structureType == structuretype).value = 0;
        props.object["Site Potential"].find((item) => item.ParameterId == 252 && item.structureType == structuretype).value = 0;
        document.getElementById(structuretype + "-38").value = 0;
        document.getElementById(structuretype + "-252").value = 0;

      }
      if (parameterid == 38) {
        props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
        props.object["Site Potential"].find((item) => item.ParameterId == 252 && item.structureType == structuretype).ischecked = false;
        props.object["Site Potential"].find((item) => item.ParameterId == 251 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-251").style.background = "#f7fafd";
        document.getElementById(structuretype + "-252").style.background = "#f7fafd";

        props.object["Site Potential"].find((item) => item.ParameterId == 252 && item.structureType == structuretype).value = 0;
        props.object["Site Potential"].find((item) => item.ParameterId == 251 && item.structureType == structuretype).value = 0;
        document.getElementById(structuretype + "-251").value = 0;
        document.getElementById(structuretype + "-252").value = 0;

      }
      if (parameterid == 252) {
        props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
        props.object["Site Potential"].find((item) => item.ParameterId == 251 && item.structureType == structuretype).ischecked = false;
        props.object["Site Potential"].find((item) => item.ParameterId == 38 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-251").style.background = "#f7fafd";
        document.getElementById(structuretype + "-38").style.background = "#f7fafd";

        props.object["Site Potential"].find((item) => item.ParameterId == 251 && item.structureType == structuretype).value = 0;
        props.object["Site Potential"].find((item) => item.ParameterId == 38 && item.structureType == structuretype).value = 0;
        document.getElementById(structuretype + "-251").value = 0;
        document.getElementById(structuretype + "-38").value = 0;

      }
      if (parameterid == 253) {
        props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
        props.object["Site Potential"].find((item) => item.ParameterId == 39 && item.structureType == structuretype).ischecked = false;
        props.object["Site Potential"].find((item) => item.ParameterId == 254 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-39").style.background = "#f7fafd";
        document.getElementById(structuretype + "-254").style.background = "#f7fafd";

        props.object["Site Potential"].find((item) => item.ParameterId == 39 && item.structureType == structuretype).value = 0;
        props.object["Site Potential"].find((item) => item.ParameterId == 254 && item.structureType == structuretype).value = 0;
        document.getElementById(structuretype + "-39").value = 0;
        document.getElementById(structuretype + "-254").value = 0;

      }
      if (parameterid == 39) {
        props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
        props.object["Site Potential"].find((item) => item.ParameterId == 253 && item.structureType == structuretype).ischecked = false;
        props.object["Site Potential"].find((item) => item.ParameterId == 254 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-253").style.background = "#f7fafd";
        document.getElementById(structuretype + "-254").style.background = "#f7fafd";

        props.object["Site Potential"].find((item) => item.ParameterId == 253 && item.structureType == structuretype).value = 0;
        props.object["Site Potential"].find((item) => item.ParameterId == 254 && item.structureType == structuretype).value = 0;
        document.getElementById(structuretype + "-253").value = 0;
        document.getElementById(structuretype + "-254").value = 0;

      }
      if (parameterid == 254) {
        props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
        props.object["Site Potential"].find((item) => item.ParameterId == 39 && item.structureType == structuretype).ischecked = false;
        props.object["Site Potential"].find((item) => item.ParameterId == 253 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-253").style.background = "#f7fafd";
        document.getElementById(structuretype + "-39").style.background = "#f7fafd";

        props.object["Site Potential"].find((item) => item.ParameterId == 39 && item.structureType == structuretype).value = 0;
        props.object["Site Potential"].find((item) => item.ParameterId == 253 && item.structureType == structuretype).value = 0;
        document.getElementById(structuretype + "-253").value = 0;
        document.getElementById(structuretype + "-39").value = 0;


      }
    }
    if (parameterid == 256) {
      props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Site Potential"].find((item) => item.ParameterId == 36 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-36").style.background = "#f7fafd";
      props.object["Site Potential"].find((item) => item.ParameterId == 258 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-258").style.background = "#f7fafd";

      props.object["Site Potential"].find((item) => item.ParameterId == 36 && item.structureType == structuretype).value = 0;
      document.getElementById(structuretype + "-36").value = 0;
      props.object["Site Potential"].find((item) => item.ParameterId == 258 && item.structureType == structuretype).value = 0;
      document.getElementById(structuretype + "-258").value = 0;

    }
    if (parameterid == 36) {
      props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Site Potential"].find((item) => item.ParameterId == 256 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-256").style.background = "#f7fafd";
      props.object["Site Potential"].find((item) => item.ParameterId == 258 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-258").style.background = "#f7fafd";

      props.object["Site Potential"].find((item) => item.ParameterId == 256 && item.structureType == structuretype).value = 0;
      document.getElementById(structuretype + "-256").value = 0;
      props.object["Site Potential"].find((item) => item.ParameterId == 258 && item.structureType == structuretype).value = 0;
      document.getElementById(structuretype + "-258").value = 0;

    }

    if (parameterid == 258) {
      props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Site Potential"].find((item) => item.ParameterId == 36 && item.structureType == structuretype).ischecked = false;
      props.object["Site Potential"].find((item) => item.ParameterId == 256 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-36").style.background = "#f7fafd";
      document.getElementById(structuretype + "-256").style.background = "#f7fafd";

      props.object["Site Potential"].find((item) => item.ParameterId == 36 && item.structureType == structuretype).value = 0;
      props.object["Site Potential"].find((item) => item.ParameterId == 256 && item.structureType == structuretype).value = 0;
      document.getElementById(structuretype + "-36").value = 0;
      document.getElementById(structuretype + "-256").value = 0;

    }

    props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).value = e.target.value;


    document.getElementById(structuretype + "-All-Def").click();

    // var formID=0;
    // let newArr =[];
    //   newArr=({
    //    ParameterId: parameterid,ParameterName: props.name,ParameterTypeId:props.ParameterTypeId,value: e.target.value,
    //    ischecked: 1,structureType: structuretype,IsManual: 0,isComplete: 0,perhomevalue: 0,perprojectvalue: 0, ParamOrder: 0,
    //  });

    //  var name=Cookies.get('username');
    //  let params = {
    //   username: name,
    //   Stage:"P",
    //   formId: formID,
    //   userType:"AutoSave",
    //   parameters: []
    //  };
    //  params.StructureTypes=[{
    //   StructureType: structuretype,
    //   Calculations: [newArr],}
    //  ]
    //  params = JSON.stringify({
    //    Body: params,
    //  });
    //  console.log(params)
    //  return axios
    //    .post('https://msbp54qxc1.execute-api.us-west-2.amazonaws.com/Prod/singlefamily', params, {
    //      headers: {
    //        "Content-Type": "application/json",
    //        Accept: "application/json",
    //      },
    //      crossorigin: true,
    //    })
    //    .then((res) => {
    //    // setLoading(false);
    //    console.log("here")
    //      return res.data;
    //    })
    //    .catch((e) => {
    //    // setLoading(false);
    //      alert(e.message);
    //    });  
  };

  const onChange1 = (e) => {
    let checkid = e.target.id;
    let parameterid = checkid.split('-')[1]
    let parametertype = checkid.split('-')[2]
    var name = Cookies.get('username');
    var value = false;
    if (parametertype == "L") {
      value = true;
    }
    var formID = 0;
    let newArr = [];
    newArr = ({
      ParameterId: parameterid, ParameterName: props.name, ParameterTypeId: props.ParameterTypeId, value: value,
      ischecked: 1, structureType: props.structureType, IsManual: 0, isComplete: 0, perhomevalue: 0, perprojectvalue: 0, ParamOrder: 0,
    });

    var name = Cookies.get('username');
    let params = {
      username: name,
      Stage: "L",
      formId: formID,
      userType: "AutoSave",
      parameters: []
    };
    params.StructureTypes = [{
      StructureType: props.structureType,
      Calculations: [newArr],
    }
    ]
    params = JSON.stringify({
      Body: params,
    });
    console.log(params)
    axios
      .post('https://msbp54qxc1.execute-api.us-west-2.amazonaws.com/Prod/singlefamily', params, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        crossorigin: true,
      })
      .then((res) => {
        // setLoading(false);
        console.log("here")
        return res.data;
      })
      .catch((e) => {
        // setLoading(false);
        alert(e.message);
      });




    // if(parametertype=="C"){
    // setLoading(true);
    // let params = {
    //   UserName: name,
    //   Stage:"P",
    //   userType:props.structureType
    // };
    // params = JSON.stringify({
    //   Body: params,
    // });
    // console.log(params)
    //  axios
    //   .post('https://msbp54qxc1.execute-api.us-west-2.amazonaws.com/Prod/getdefaults', params, {
    //     headers: {
    //       "Content-Type": "application/json",
    //       Accept: "application/json",
    //     },
    //     crossorigin: true,
    //   })
    //   .then((res) => {
    //     setLoading(false);
    //   })
    //   .catch((e) => {
    //     setLoading(false);

    //   });
    //}

    //setIsChecked(!isChecked);
    let structuretype = checkid.split('-')[0];


    if (e.target.checked == true) {
      setValue("checked");
      var divElement = document.querySelector('.Tab-' + structuretype.replace(/\s/g, ""));


      // Retrieve all input elements within the div
      var inputElements = divElement.querySelectorAll('input');

      // Iterate over each input element and set the readOnly property
      for (var i = 0; i < inputElements.length; i++) {
        inputElements[i].readOnly = false;

      }
      document.getElementById("290-" + props.structureType + "-btn").style.display = "initial";
      document.getElementById("289-" + props.structureType + "-btn").style.display = "initial";
      var ss = document.getElementById(props.structureType + "-All-Def");
      ss.style.display = "initial";

      var elements = document.getElementsByClassName('adminDefault')
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.display = 'none';
      }
      var elements1 = document.getElementsByClassName('UserDefault')

      for (var i = 0; i < elements1.length; i++) {
        elements1[i].style.display = 'inherit';
      }
      var divElement = document.querySelector('.Tab-' + structuretype.replace(/\s/g, ""));
      var inputElements = divElement.querySelectorAll('input');

      // Iterate over each input element and set the readOnly property
      for (var i = 0; i < inputElements.length; i++) {
        inputElements[i].readOnly = false;
      }
      var elements2 = document.getElementsByClassName('Defsoftcost1')
      for (var i = 0; i < elements2.length; i++) {
        elements2[i].style.display = 'initial';
      }
      var elements3 = document.getElementsByClassName('Defhardcost1')
      for (var i = 0; i < elements3.length; i++) {
        elements3[i].style.display = 'initial';
      }
      //document.getElementsByName(props.structureType.replace(/\s/g, "")+"-btn").style.display = "initial";
      var toogle = document.getElementsByClassName('Defaulttoogle')
      if (props.isManual == 0) {
        setIsChecked(true)

      }

      for (var i = 0; i < toogle.length; i++) {
        toogle[i].checked = true;

      }
      props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).value = "true";
      props.setData({ ...props.wholeEl, value: 'true', ischecked: true })

      console.log(props.object["Site Potential"]);

    }
    else {
      //   var toogle = document.getElementsByClassName('Defaulttoogle')
      //   for (var i = 0; i < toogle.length; i++){
      //     toogle[i].checked=false;
      //   }
      var ss = document.getElementById(props.structureType + "-All-Def");
      ss.style.display = "none";
      // var childDiv = document.getElementById("toggle");
      // childDiv.style.display = "block";
      // var divElement = document.querySelector('.adminDefault');
      // var inputElements = divElement.querySelectorAll('input');
      // for (var i = 0; i < inputElements.length; i++) {
      //   inputElements[i].readOnly = true;
      // }
      var elements = document.getElementsByClassName('adminDefault')
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.display = 'inherit';
      }
      var elements1 = document.getElementsByClassName('UserDefault')

      for (var i = 0; i < elements1.length; i++) {
        elements1[i].style.display = 'none';
      }

      var elements2 = document.getElementsByClassName('Defsoftcost1')
      for (var i = 0; i < elements2.length; i++) {
        elements2[i].style.display = 'none';
      }
      var elements3 = document.getElementsByClassName('Defhardcost1')
      for (var i = 0; i < elements3.length; i++) {
        elements3[i].style.display = 'none';
      }
      document.getElementById("290-" + props.structureType + "-btn").style.display = "none";
      document.getElementById("289-" + props.structureType + "-btn").style.display = "none";
      var divElement = document.querySelector('.Tab-' + structuretype.replace(/\s/g, ""));

      var inputElements = divElement.querySelectorAll('input');

      for (var i = 0; i < inputElements.length; i++) {
        inputElements[i].readOnly = true;
      }

      var toogle = document.getElementsByClassName('Defaulttoogle')
      if (props.isManual == 0) {
        setIsChecked(false)

      }

      for (var i = 0; i < toogle.length; i++) {
        toogle[i].checked = false;
      }

      props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).value = "false";
      props.setData({ ...props.wholeEl, value: 'false', ischecked: true })
    }
  };
  if (props.id == 1000 && props.IsManual == 12) {

    return (
      <>

        <div class="col-md-2 toggle" tooltip="LandBridge Defaults" flow="down" style={{ width: "100%", alignItems: "center", marginTop: "-20%", marginLeft: "0%", height: "50%", }}>

          <input key={props.structureType + "-" + props.id}
            id={props.structureType + "-" + props.id + "-L"} type="checkbox" onChange={onChange1} class={"Defaulttoogle"}>
          </input>
          <label  ></label>
        </div>
        <div class="col-md-10"></div>
      </>
    );


  }
  if (props.id == 1000 && props.IsManual == 0) {

    return (
      <>

        <div class="col-md-2 toggle" tooltip="Custom Defaults" flow="down" style={{ width: "100%", alignItems: "center", marginTop: "-20%", marginLeft: "0%", height: "50%", }}>

          <input key={props.structureType + "-" + props.id}
            id={props.structureType + "-" + props.id + "-C"} type="checkbox" checked onChange={onChange1} class={"Defaulttoogle"} >
          </input>
          <label  ></label>
        </div>
        <div class="col-md-10"></div>
      </>
    );




  }

  if (props.id == 284 || props.id == 285 || props.id == 286) {
    return (
      <div class="col-md-12 mt-2" style={{}}>
        <div class="from mt-2 d-flex justify-content-between  align-items-center ">
          <label class="mr-1" >{props.name}
          </label>
          <input
            type="text"
            key={props.structureType + "-" + props.id}
            id={props.structureType + "-" + props.id}
            value={value}
            readOnly
            class="form-control"
            style={{ maxWidth: "70%" }}
          />
        </div>
      </div>
    );
  }
  if (props.id == 256 || props.id == 36 || props.id == 258 || props.id == 69) {
    if (props.id == 258) {
      return (

        <>


          <div class="col-md-4 col" >
            <div class="from  d-flex justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly
                  class={IsStyle}

                />
              </div>
            </div>
          </div>

        </>
      );
    }
    else {
      if (props.id == 256) {
        if (props.structureType == "Single Family") {
          return (

            <>

              <div class="col-md-6" >
                <div class="from  d-flex justify-content-between  align-items-center ">
                  <label class=""><u>Total Estimated Value</u>


                  </label>



                </div>
              </div>


            </>
          );
        }
        else {

          return (

            <>


              <div class="col-md-11 input-box1 mt-3">
                <div class="row" style={{ width: "107%" }}>
                  <div class="col-md-3"></div>
                  <div class="col-md-2 col"><label class="d-block text-center">Per sqft</label></div>
                  <div class="col-md-3 col"><label class="d-block text-center">{structureType}</label></div>
                  <div class="col-md-3 col"><label class="d-block text-center">Project</label></div>
                </div></div>
              <div class="col-md-3 ml-2" >
                <div class="from  d-flex justify-content-between  align-items-center ">
                  <label class="">{props.name.split('Per')[0]}


                  </label>



                </div>
              </div>

              <div class="col-md-3 col">
                <div class="from  d-flex justify-content-between  align-items-center ">
                  <div class="test">
                    <input
                      type="text"
                      key={props.structureType + "-" + props.id}
                      id={props.structureType + "-" + props.id}
                      value={value}
                      onChange={onChange}
                      //placeholder={props.name.split('Per')[0]}

                      class={IsStyle}

                    />
                  </div>
                </div>
              </div>

            </>
          );
        }


      } else {

        return (

          <>


            <div class="col-md-3 col" >
              <div class="from  d-flex justify-content-between  align-items-center ">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    //placeholder={props.name.split('Per')[0]}

                    class={IsStyle}

                  />
                </div>
              </div>
            </div>
          </>
        );
      }
    }
  }
  if (props.id == 37 || props.id == 249 || props.id == 250) {
    if (props.id == 249) {


      return (

        <>
          <div class="ml-2 table-outer mt-4">
            <div class="row mytable ">

              <div class="col-md-11 input-box1 ">
                <div class="row" style={{ width: "100%" }}>
                  <div class="col-md-3"></div>
                  <div class="col-md-3 col"><label class="d-block text-center">Per sqft </label></div>
                  <div class="col-md-3 col"><label class="d-block text-center">{structureType}</label></div>
                  <div class="col-md-3 col"><label class="d-block text-center">Project</label></div>
                </div></div>
              <div class="col-md-3" >
                <div class="from  d-flex justify-content-between  align-items-center ">
                  <label class="">{props.name.split('Per')[0]}

                  </label>



                </div>
              </div>

              <div class="col-md-3 col">
                <div class="from  d-flex justify-content-between  align-items-center ">
                  <div class="test">
                    <input
                      type="text"
                      key={props.structureType + "-" + props.id}
                      id={props.structureType + "-" + props.id}
                      value={value}
                      onChange={onChange}
                      //placeholder={props.name.split('Per')[0]}
                      readOnly
                      class={IsStyle}

                    />
                  </div>
                </div>
              </div> </div>
          </div>
        </>
      );

    } else {

      return (

        <>


          <div class="col-md-3 col" >
            <div class="from  d-flex justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}

                  class={IsStyle}
                  readOnly
                />
              </div>
            </div>
          </div>
        </>
      );
    }
  }

  if (props.id == 30 || props.id == 96 || props.id == 215 || props.id == 199 || props.id == 80 || props.id == 71 || props.id == 216 || props.id == 79 || props.id == 188 || props.id == 32 || props.id == 33 || props.id == 35 || props.id == 67 || props.id == 34) {
    if (props.id == 30 || props.id == 199 || props.id == 215 || props.id == 80 || props.id == 216 || props.id == 188 || props.id == 32 || props.id == 33 || props.id == 34 || props.id == 35 || props.id == 67) {
      if (props.id == 199) {



        return (
          <>
            <div class="col-md-5 col" style={{}}>
              <div class="from row justify-content-between  align-items-center ">
                <label class="mr-1 col-md-6">{props.name}
                </label>

                <input

                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name}
                  readOnly
                  class="form-control col-md-5"

                />

              </div>
            </div>
            <div class="col-md-6"></div></>
        );
      }
      else {
        if (props.ischecked == true) {

          return (
            <div class="col-md-5 col" style={{}}>
              <div class="from row justify-content-between  align-items-center ">
                <label class="mr-1 col-md-6">{props.name}
                </label>

                <input
                  style={{ backgroundColor: "#e7f0fa" }}
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name}

                  class="form-control col-md-5"

                />

              </div>
            </div>
          );
        }
        else {
          return (
            <div class="col-md-5 col" style={{}}>
              <div class="from row justify-content-between  align-items-center ">
                <label class="mr-1 col-md-6">{props.name}
                </label>

                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name}

                  class="form-control col-md-5"

                />
              </div>
            </div>
          );
        }
      }
    }
    else if (props.id == 71) {

      return (
        <div class="col-md-6 col" style={{}}>
          <div class="from mt-2 d-flex justify-content-between  align-items-center ">
            <label class="mr-1">{props.name}


            </label>

            <input

              type="text"
              key={props.structureType + "-" + props.id}
              id={props.structureType + "-" + props.id}
              value={value}
              onChange={onChange}
              //placeholder={props.name}
              readOnly
              class="form-control"

            />

          </div>
        </div>
      );
    }
    else if (props.id == 79) {

      return (
        <div class="col-md-6 mb-2 " style={{}}>

          <div class="row" >

            <div class="col-md-6"> <label class="mr-1">{props.name}
            </label></div>
            <div class="col-md-5 col">
              <div class="test1"> <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                class="form-control  construction"
                style={{ borderRadius: "5px", marginBottom: "5px" }}
              /></div>
            </div>
          </div>



        </div>

      );

    }

    else {
      if (props.ischecked == true) {

        return (
          <div class="col-md-5 col" style={{}}>
            <div class="from row   align-items-center ">
              <label class="col-md-6 col">{props.name}

              </label>

              <input
                style={{ backgroundColor: "#e7f0fa", borderRadius: "5px" }}
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name}

                class="form-control col-md-5 col"

              />

            </div>
          </div>
        );
      }
      else {
        return (
          <div class="col-md-5 col" style={{}}>
            <div class="from row   align-items-center ">
              <label class="col-md-6 col">{props.name}

              </label>

              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name}
                style={{ borderRadius: "5px" }}
                class="form-control col-md-5 col"

              />
            </div>
          </div>
        );
      }
    }

  }
  else {
    if (props.id == 185) {

      if (props.ischecked == true) {

        return (
          <>
            <div class="from mt-2 ml-2">
              <label class="d-block">{props.name}
              </label>

              <input

                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name}
                readOnly
                class="form-control"

              />

            </div>
            <div class="row ml-2" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.2)", width: "90%" }}></div>
          </>
        );
      }
      else {
        return (
          <>
            <div class="from mt-2 ml-2">
              <label class="d-block">{props.name}
              </label>

              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name}
                readOnly
                class="form-control"

              />
            </div>
            <div class="row ml-2" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.2)", width: "100%" }}></div>
          </>
        );
      }

    }
    else {
      if (props.id == 184) {

        if (props.ischecked == true) {

          return (
            <div class="from mt-2 ml-2">
              <label class="d-block">{props.name}
              </label>

              <input

                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name}
                readOnly
                class="form-control"

              />

            </div>
          );
        }
        else {
          return (
            <div class="from mt-2 ml-2">
              <label class="d-block">{props.name}
              </label>

              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name}
                readOnly
                class="form-control"

              />
            </div>
          );
        }
      }
      else {
        if (props.isManual == true) {

          return (
            <div class="from mt-2 ml-2">
              <label class="d-block">{props.name}

              </label>

              <input

                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name}
                readOnly
                class="form-control"

              />

            </div>
          );
        }
        else {
          return (
            <div class="from mt-2 ml-2">
              <label class="d-block">{props.name}

              </label>

              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name}
                readOnly
                class="form-control"

              />
            </div>
          );
        }
      }
    }
  }

}
export default SitePotentialD;
